import { Link, useLocation } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';

export default function Header() {
    const location = useLocation();
    const isLargeScreen = useMediaQuery('(min-width: 1024px)');
    const isContactPage = location.pathname === "/contact";

    return (
        <header className={`${isLargeScreen && isContactPage ? "bg-[#00101D] bottom-0 z-30 w-full md:top-0 text-white":"md:absolute fixed bottom-0 z-30 w-full md:top-0 text-white"}`}>
            <div className="container mx-auto p-6 justify-between items-center hidden md:flex">
                {/* Logo */}
                <div className="flex items-center">
                    <Link to="/" className="flex items-center">
                        <img src="/assets/logo.svg" alt="Everest Apps Logo" className="h-8 md:h-12 lg:h-16" />
                    </Link>
                </div>

                {/* Main Navigation */}
                <nav className="flex items-center gap-x-12 ml-12">
                    <Link to="/feature" className="font-bold text-white md:text-xl hover:text-blue-300 transition duration-150">Features</Link>
                    <Link to="/portfolio" className="font-bold text-white md:text-xl hover:text-blue-300 transition duration-150">Portfolio</Link>
                    <Link to="/team" className="font-bold text-white md:text-xl hover:text-blue-300 transition duration-150">Team</Link>
                </nav>

                {/* Call to Action Button */}
                <div className="">
                    <Link to="/contact" className="font-bold bg-background-blue text-[18px] text-white px-6 py-3 rounded-full hover:bg-blue-600 transition duration-150">
                        Let's Chat Now!
                    </Link>
                </div>
            </div>

            <div className='w-full bg-[#041421] border-t border-[#0F416A] flex sm:gap-10 sm:justify-center justify-between py-4 px-10 md:hidden'>
                <Link to="/" className="font-bold text-white text-xs hover:text-blue-300 transition duration-150 flex flex-col justify-center items-center gap-0.5">
                    <img src="/assets/home-icon-mobile.svg" alt="Home" className='w-7' />
                    Home</Link>
                <Link to="/feature" className="font-bold text-white text-xs hover:text-blue-300 transition duration-150 flex flex-col justify-center items-center gap-0.5">
                    <img src="/assets/feature-icon-mobile.svg" alt="Home" className='w-7' />
                    Features</Link>
                <Link to="/portfolio" className="font-bold text-white text-xs hover:text-blue-300 transition duration-150 flex flex-col justify-center items-center gap-0.5">
                    <img src="/assets/portfolio-icon-mobile.svg" alt="Home" className='w-7' />
                    Portfolio</Link>
                <Link to="/team" className="font-bold text-white text-xs hover:text-blue-300 transition duration-150 flex flex-col justify-center items-center gap-0.5">
                    <img src="/assets/team-icon-mobile.svg" alt="Home" className='w-7' />
                    Team</Link>
                <Link to="/contact" className="font-bold text-white text-xs hover:text-blue-300 transition duration-150 flex flex-col justify-center items-center gap-0.5">
                    <img src="/assets/chat-icon-mobile.svg" alt="Home" className='w-7' />
                    Chat</Link>
            </div>
        </header>
    );
}